<template>
	<li
		class="last-orders__item"
	>
		<span
			class="last-orders__item-date"
			v-html="displayDate"
		/>
		<span
			class="last-orders__item-total"
			v-html="$options.filters.fwgpricecent(order.total)"
		/>
		<div
			class="last-orders__item-items"
		>
			<span
				class="last-orders__item-items-text"
				:class="{
					'last-orders__item-items-text--open': showMore
				}"
				v-html="items"
			/>
			<a
				v-if="exceedsThreshold"
				class="last-orders__item-items-more"
				v-html="showMoreText"
				@click="onShowMore"
			/>
		</div>
		<ul class="last-orders__item-icons">
			<li class="last-orders__item-icon">
				<component
					class="last-orders__item-icon-icon"
					:is="iconComponent(order.shipmentCode)"
				/>
				<span
					class="last-orders__item-icon-text"
					v-html="shipmentName(order.shipmentCode)"
				/>
			</li>
			<li class="last-orders__item-icon">
				<SVGLocation
					class="last-orders__item-icon-icon"
				/>
				<span
					class="last-orders__item-icon-text"
					v-html="order.channelName"
				/>
			</li>
		</ul>
		<Button
			class="last-orders__item-button"
			@click.prevent="$emit('click', order.tokenValiue)"
			level="secondary"
			:text="$t('shoplist.lastOrders.reorderButton')"
			type="button"
			small
		/>
	</li>
</template>

<script>
import Button from '@/components/Button';

export default {
	components: {
		Button,
	},
	props: {
		order: Object
	},
	data() {
		return {
			showMore: false,
			// the threshold should always be higher than the substring length,
			// otherwise the show more button would only reveal a few characters.
			exceedsThreshold: this.order.itemsLine.length >= 70,
			monthNames: [
				this.$t('dates.months.january'),
				this.$t('dates.months.february'),
				this.$t('dates.months.march'),
				this.$t('dates.months.april'),
				this.$t('dates.months.may'),
				this.$t('dates.months.june'),
				this.$t('dates.months.july'),
				this.$t('dates.months.august'),
				this.$t('dates.months.september'),
				this.$t('dates.months.october'),
				this.$t('dates.months.november'),
				this.$t('dates.months.december'),
			],
		}
	},
	computed: {
		displayDate() {
			const date = new Date(this.order.checkoutCompletedAt);
			const day = date.getDate();
			const month = this.monthNames[date.getMonth()];
			const year = date.getFullYear();

			return `${day}. ${month} ${year}`;
		},
		items() {
			return this.showMore || !this.exceedsThreshold ? this.order.itemsLine : `${this.order.itemsLine.substring(0, 50)}...`;
		},
		showMoreText() {
			return this.showMore ? this.$t('shoplist.lastOrders.showLess') : this.$t('shoplist.lastOrders.showMore');
		}
	},
	methods: {
		shipmentName(code) {
			return code === 'delivery' ? this.$t('shoplist.lastOrders.delivery') : this.$t('shoplist.lastOrders.takeaway');
		},
		onShowMore() {
			this.showMore = !this.showMore;
		},
	}
}
</script>

<style>

</style>
